var _defs, _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconJoyStationLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .joyStation {\n        fill: none;\n        stroke: currentColor;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "joyStation",
    cx: 25,
    cy: 20.74,
    rx: 17.18,
    ry: 13.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "joyStation",
    d: "M41.42,16.77c.49,1.25.75,2.59.75,3.97,0,7.46-7.69,13.5-17.18,13.5S7.82,28.19,7.82,20.74c0-1.38.26-2.71.75-3.97-2.75,2.73-4.4,6.16-4.4,9.89,0,8.89,9.32,16.1,20.82,16.1s20.82-7.21,20.82-16.1c0-6.31-4.39-9.89-4.4-9.89h.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconJoyStationLine);
export default __webpack_public_path__ + "static/media/cloud_icon_JoyStation_line.d95bf562c37b64700a5b863158b0f3cf.svg";
export { ForwardRef as ReactComponent };